import React from 'react'
import { Card, Box, StackView, Tooltip } from '@telus-uds/components-web'
import Icon from 'src/siteBuilder/blocks/core/Icon/Icon'

export type PepOffersProps = {
  iconName?: string
  offerText?: React.ReactNode
  showTooltip?: boolean
  tooltipInfoText?: string
}

const PepOffers = ({ iconName = 'Gift', offerText, showTooltip, tooltipInfoText }: PepOffersProps) => {
  return (
    <Card
      variant={{ background: 'feature' }}
      // Asymmetric padding offsets the icon's Box horizontal spacing to match the Figma spec.
      tokens={{
        paddingBottom: 13,
        paddingLeft: 9,
        paddingRight: 17,
        paddingTop: 13,
        borderWidth: 1,
      }}
    >
      <StackView direction="row">
        {iconName && (
          <Box horizontal={2}>
            <Icon iconName={iconName} color="brand" />
          </Box>
        )}
        <Box flex={1}>{offerText}</Box>
        <Box>{showTooltip && tooltipInfoText && <Tooltip content={tooltipInfoText} />}</Box>
      </StackView>
    </Card>
  )
}

export default PepOffers
